// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PPUyS6aLH3aExo {
  border-radius: var(--ds-border-radius-200, 8px);
}
.PPUyS6aLH3aExo:focus,
.PPUyS6aLH3aExo:active,
.PPUyS6aLH3aExo.DL0veV_gqM5jaG {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .PPUyS6aLH3aExo:focus,
.mac .PPUyS6aLH3aExo:active,
.mac .PPUyS6aLH3aExo.DL0veV_gqM5jaG {
  outline-color: -webkit-focus-ring-color;
}
.PPUyS6aLH3aExo:focus .mac.firefox,
.PPUyS6aLH3aExo:active .mac.firefox,
.PPUyS6aLH3aExo.DL0veV_gqM5jaG .mac.firefox {
  outline-color: AccentColor;
}
.PPUyS6aLH3aExo.VA_DrAxa0egsmI {
  min-width: 120px;
  height: auto;
  margin: var(--ds-space-050, 4px);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  text-align: center;
}
`, ""]);
// Exports
export var createBoardTile = `PPUyS6aLH3aExo`;
export var active = `DL0veV_gqM5jaG`;
export var grid = `VA_DrAxa0egsmI`;
export default ___CSS_LOADER_EXPORT___;
